import React from 'react'
import { useIntl } from 'react-intl'
import { useCurrency } from 'msp-integrations'
import * as S from './AccountHeader.styles'
import * as T from './AccountHeader.types'

const AccountHeader = ({ customer }: T.AccountHeaderProps) => {
  const { formatMessage, formatNumber } = useIntl()
  const { currency: activeCurrency } = useCurrency()
  const remainingGiftCredit = formatNumber(customer?.c_customerCredit || 0, {
    style: 'currency',
    currency: activeCurrency,
    currencyDisplay: 'code'
  })

  return (
    <>
      <div className={S.AccountHeaderWrapper}>
        <h1 className={S.AccountHeaderCustomerGreeting}>
          {formatMessage(
            {
              defaultMessage: 'Hello, {firstName}!',
              id: 'account.profile_card.welcome'
            },
            {
              firstName: customer?.firstName || ''
            }
          )}
        </h1>
        <div className={S.AccountHeaderCustomerInfoWrapper}>
          <div className={S.AccountHeaderCustomerInfoContent}>
            <span>
              {formatMessage({
                defaultMessage: 'Customer Number',
                id: 'msp.account_detail.customer.number'
              })}
              :
            </span>
            <span className={S.AccountHeaderCustomerInfoContentValue}>
              {customer?.customerNo || ''}
            </span>
          </div>
          <div className={S.AccountHeaderCustomerInfoContent}>
            <span>
              {formatMessage({
                defaultMessage: 'Credit Balance',
                id: 'msp.account_detail.customer.credit'
              })}
              :
            </span>
            <span className={S.AccountHeaderCustomerInfoContentValue}>
              {remainingGiftCredit}
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export default AccountHeader
